import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Stack } from '@mui/material'
import React from 'react'
import { InstallationWithoutAccess } from 'src/Libs/installations/models'
import InstallationWithoutAccessImage from './InstallationWithoutAccessImage'

interface Props {
  installation: InstallationWithoutAccess
}

/**
 * Display image and type for installation without access.
 */
const InstallationWithoutAccessProductType: React.FC<Props> = ({ installation }) => {
  const { t } = useCustomTranslation()
  const { isFarm, emsMasterProduct } = installation
  const productType = isFarm ? t('installation.overview.farm') : emsMasterProduct
  return (
    <Stack flexDirection="row" alignItems="center" justifyContent="left" gap={1}>
      {<InstallationWithoutAccessImage installation={installation} />}
      {productType}
    </Stack>
  )
}

export default InstallationWithoutAccessProductType
